import { Injectable } from '@angular/core';
import { BodyInnerEmbeddedService } from '@app/core/services/body-inner-embedded.service';
import { LoadingComponent } from './loading.component';

@Injectable({ providedIn: 'root' })
export class CustomLoadingService {
    constructor(private bodyEmbedded: BodyInnerEmbeddedService) {}

    show(): void {
        this.bodyEmbedded.appendComponentToBody(LoadingComponent);
    }

    hide(): void {
        this.bodyEmbedded.detachComponentFromBody();
    }
}
